import type { ClientInitChannelMarkup } from 'api/promo'
import { evaluateChannelMarkup } from './channelMarkup'

function getChannelMarkupFilters(search: string): App.ChannelMarkupFilters {
  const searchParams = new URLSearchParams(search)
  return {
    source: searchParams.get('utm_source') ?? '',
    medium: searchParams.get('utm_medium') ?? '',
    campaign: searchParams.get('utm_campaign') ?? '',
    term: searchParams.get('utm_term'),
  }
}

export default function selectChannelMarkup(
  channelMarkupConfig: ClientInitChannelMarkup,
  search: string,
): App.ChannelMarkup | undefined {
  const channelMarkups = channelMarkupConfig.channelMarkupListV2 as unknown as Array<App.ChannelMarkup> | undefined
  if (!channelMarkups?.length) {
    return undefined
  }

  return evaluateChannelMarkup(channelMarkups, getChannelMarkupFilters(search))
}
